import { UseCase } from '@/domain/core/UseCase'
import { Result } from '@/domain/protocols/Result'

import type { IUserGeometryRepository } from '@/data/UserGeometryRepository/IUserGeometryRepository'

// Case-insensitive uniqueness check on the display name (soft-deleted rows ignored).
export class CheckUserGeometryNameExistsUseCase implements UseCase<string, Promise<Result<boolean>>> {
  constructor(private readonly repository: IUserGeometryRepository) {}

  async execute(name: string): Promise<Result<boolean>> {
    try {
      return await this.repository.existsByName(name)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
